import * as ents from '@attain-apps/entities'
import type * as chartJs from 'chart.js'

import * as colors from '../../../colors'

/**
 * Transform data from
 * {@link ents.core.display.chart.data.Of<ents.core.display.chart.Type.DonutChart>} to
 * {@link chartJs.ChartData<'doughnut'>}
 */
export function getData(
  data: ents.core.display.chart.data.Of<ents.core.display.chart.Type.Donut>,
): chartJs.ChartData<'doughnut'> {
  const { slices } = data

  if (!slices) {
    return { datasets: [], labels: [] }
  }
  const palette = colors.createPalette(ents.core.display.chart.Type.Donut)

  // NOTE: Small slices (< 1%) are combined into 'Others' category
  let othersValue = 0
  const chartSlices = []

  // Calculate the total sum of all slice values
  const totalSliceValue = slices.reduce(
    (total, slice) => total + (slice.value ?? 0),
    0,
  )

  for (const slice of slices) {
    const sliceProportion = slice.value ? slice.value / totalSliceValue : 0

    // If the slice proportion is less than 0.01, add it to the 'Others' category
    if (sliceProportion < 0.01) {
      othersValue += slice.value ?? 0
    } else {
      // Otherwise, include the slice as a separate category
      chartSlices.push(slice)
    }
  }

  // If there are slices grouped into 'Others', add 'Others' to the chartSlices
  if (othersValue > 0) {
    chartSlices.push({
      name: 'Others',
      value: othersValue,
    })
  }

  return {
    datasets: [
      {
        backgroundColor: chartSlices.map((slice, i) =>
          palette.getOrAssignColorFor(slice.name ?? i.toString()),
        ),
        data: chartSlices.map(slice => slice.value ?? 0),
      },
    ],
    labels: chartSlices.map(slice => slice.name),
  }
}
